import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "pages.add-user",
    path: `${APP_PREFIX_PATH}/pages/add-user`,
    component: React.lazy(() => import("views/app-views/pages/add-user")),
  },
  {
    key: "pages.edit-user",
    path: `${APP_PREFIX_PATH}/pages/edit-user/:id`,
    component: React.lazy(() => import("views/app-views/pages/edit-user")),
  },
  {
    key: "pages.user-list",
    path: `${APP_PREFIX_PATH}/pages/user-list`,
    component: React.lazy(() => import("views/app-views/pages/user-list")),
  },
  {
    key: "pages.admin",
    path: `${APP_PREFIX_PATH}/pages/admin`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "pages.reports",
    path: `${APP_PREFIX_PATH}/pages/reports`,
    component: React.lazy(() => import("views/app-views/pages/reports")),
  },
  {
    key: "pages.finance",
    path: `${APP_PREFIX_PATH}/pages/finance`,
    component: React.lazy(() =>
      import("views/app-views/pages/finance/finance.jsx")
    ),
  },
  {
    key: "pages.finance",
    path: `${APP_PREFIX_PATH}/pages/get-single-finance/:id`,
    component: React.lazy(() =>
      import("views/app-views/pages/finance/get-single-finance.jsx")
    ),
  },
];
